import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const SMS_CAMPAIGN_API_URL = "dialer/sms-campaigns/";

export const fetchSmsCampaigns = createAsyncThunk("smsCampaigns/fetchSmsCampaigns", async (params, thunkAPI) => {
    try {
        const state = thunkAPI.getState();
        const token = state.auth.token;
        if (!token) return;

        const response = await axios.get(SMS_CAMPAIGN_API_URL, {
            params: params,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }
        });

        console.log(response, "=====smsCampaign response====");
        return response?.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(
            error.response?.data?.message ||
            error.message ||
            "Failed to fetch SMS campaigns list"
        );
    }
});


const smsCampaignSlice = createSlice({
    name: "smsCampaign",
    initialState: {
        sms_campaigns_list: [],
        sms_campaign_list_loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchSmsCampaigns.pending, (state) => {
            state.sms_campaign_list_loading = true;
            state.error = null;
        })
        .addCase(fetchSmsCampaigns.fulfilled, (state, action) => {
            state.sms_campaign_list_loading = false;
            state.sms_campaigns_list = action.payload;
        })
        .addCase(fetchSmsCampaigns.rejected, (state, action) => {
            state.sms_campaign_list_loading = false;
            state.error = action.payload || "Something went wrong";
            state.sms_campaigns_list = [];
        });
    },
});

export default smsCampaignSlice.reducer;